import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface ProfileState {
    fetching: boolean;
}

export default makeReducer<ProfileState>(
    [
        match(Actions.fetch, state => ({...state, fetching: true})),
        match(Actions.fetchFailed, state => ({...state, fetching: false})),
        match(Actions.fetchSuccess, state => ({...state, fetching: false})),
        match(Actions.fetchRecurringPayments, state => ({...state, fetching: true})),
        match(Actions.fetchRecurringPaymentsFailed, state => ({...state, fetching: false})),
        match(Actions.fetchRecurringPaymentsSuccess, state => ({...state, fetching: false})),
    ],
    {fetching: false},
);
